module.exports = __webpack_public_path__ + "img/feature-08.feb43e59.png";